import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import GateIntro from "./components/feature/GateIntro";
import PageTransition from "./components/feature/PageTransition";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <GateIntro>
          <PageTransition>
            <AppRoutes />
          </PageTransition>
        </GateIntro>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;